{
  "expo": {
    "name": "IoT Edge",
    "slug": "iot-edge",
    "version": "2.3.32",
    "orientation": "default",
    "icon": "./assets/icon.png",
    "userInterfaceStyle": "automatic",
    "splash": {
      "image": "./assets/splash.png",
      "resizeMode": "cover",
      "backgroundColor": "#1e3a8a"
    },
    "updates": {
      "enabled": true,
      "fallbackToCacheTimeout": 0,
      "checkAutomatically": "ON_LOAD",
      "url": "https://u.expo.dev/e9d25671-93f1-4f8b-8a5f-553495157790"
    },
    "extra": {
      "eas": {
        "projectId": "e9d25671-93f1-4f8b-8a5f-553495157790"
      },
      "disableErrorRecovery": true,
      "apiBaseUrl": "https://api.iot-edge.io/api/v1",
      "fallbackApiUrl": "http://72.60.214.199:3001/api/v1"
    },
    "assetBundlePatterns": [
      "**/*"
    ],
    "ios": {
      "supportsTablet": true,
      "bundleIdentifier": "com.de.iotedge",
      "buildNumber": "84",
      "googleServicesFile": "./GoogleService-Info.plist",
      "infoPlist": {
        "NSCameraUsageDescription": "نحتاج الوصول للكاميرا لمسح رموز QR الخاصة بتسجيل الأجهزة | We need camera access to scan QR codes for device registration.",
        "NSLocationWhenInUseUsageDescription": "نحتاج الموقع لإدارة الأجهزة وعرضها على الخريطة | We need location access for device management and map display.",
        "NSUserNotificationsUsageDescription": "نحتاج إرسال إشعارات لتنبيهك بالتنبيهات الحرجة والتحديثات المهمة | We need to send notifications to alert you about critical alarms and important updates.",
        "NSFaceIDUsageDescription": "نستخدم Face ID لتسجيل دخول آمن ومريح | We use Face ID for secure and convenient login.",
        "ITSAppUsesNonExemptEncryption": false,
        "UIBackgroundModes": [
          "remote-notification",
          "fetch"
        ]
      },
      "entitlements": {
        "aps-environment": "production",
        "com.apple.developer.usernotifications.time-sensitive": true
      }
    },
    "android": {
      "adaptiveIcon": {
        "foregroundImage": "./assets/adaptive-icon.png",
        "backgroundColor": "#ffffff"
      },
      "package": "com.de.iotedge",
      "versionCode": 196,
      "googleServicesFile": "./google-services.json",
      "permissions": [
        "CAMERA",
        "ACCESS_COARSE_LOCATION",
        "RECEIVE_BOOT_COMPLETED",
        "VIBRATE",
        "USE_BIOMETRIC",
        "USE_FINGERPRINT",
        "android.permission.WAKE_LOCK",
        "android.permission.POST_NOTIFICATIONS"
      ],
      "blockedPermissions": [
        "android.permission.RECORD_AUDIO",
        "android.permission.READ_EXTERNAL_STORAGE",
        "android.permission.WRITE_EXTERNAL_STORAGE",
        "android.permission.SCHEDULE_EXACT_ALARM",
        "android.permission.DETECT_SCREEN_CAPTURE",
        "android.permission.FOREGROUND_SERVICE",
        "android.permission.FOREGROUND_SERVICE_DATA_SYNC",
        "android.permission.FOREGROUND_SERVICE_CAMERA",
        "android.permission.FOREGROUND_SERVICE_LOCATION",
        "android.permission.FOREGROUND_SERVICE_MEDIA_PLAYBACK",
        "android.permission.FOREGROUND_SERVICE_MEDIA_PROJECTION",
        "android.permission.FOREGROUND_SERVICE_MICROPHONE",
        "android.permission.FOREGROUND_SERVICE_CONNECTED_DEVICE",
        "android.permission.FOREGROUND_SERVICE_PHONE_CALL",
        "android.permission.FOREGROUND_SERVICE_HEALTH",
        "android.permission.FOREGROUND_SERVICE_REMOTE_MESSAGING",
        "android.permission.FOREGROUND_SERVICE_SYSTEM_EXEMPTED",
        "android.permission.READ_MEDIA_IMAGES",
        "android.permission.READ_MEDIA_VIDEO",
        "android.permission.READ_MEDIA_VISUAL_USER_SELECTED"
      ]
    },
    "web": {
      "bundler": "metro",
      "favicon": "./assets/favicon.png"
    },
    "plugins": [
      "./node_modules/@react-native-firebase/app/app.plugin.js",
      "./node_modules/@react-native-firebase/messaging/app.plugin.js",
      [
        "expo-notifications",
        {
          "icon": "./assets/notification-icon.png",
          "color": "#ffffff"
        }
      ],
      "expo-local-authentication",
      "@react-native-community/datetimepicker",
      [
        "expo-camera",
        {
          "cameraPermission": "Allow $(PRODUCT_NAME) to access your camera to scan QR codes."
        }
      ],
      [
        "expo-build-properties",
        {
          "ios": {
            "useFrameworks": "static"
          },
          "android": {
            "extraMavenRepos": [
              "$rootDir/../node_modules/@notifee/react-native/android/libs"
            ],
            "usesCleartextTraffic": false
          }
        }
      ],
      "./plugins/withNotificationIcon.js",
      "./plugins/withAndroidManifestFix.js",
      "./plugins/withFirebaseAppDelegate.js",
      "./plugins/withIosRelaxedBuildSettings.js",
      "./plugins/withPodfileRelaxedV2.js",
      "./plugins/withGradlePropertiesFix.js",
      "expo-image",
      "expo-secure-store",
      "expo-sharing"
    ],
    "owner": "abood-alshami",
    "runtimeVersion": "2.3.13"
  }
}
